import * as React from 'react'
import * as PopoverPrimitive from '@radix-ui/react-popover'
import { cn } from '@/lib/utils'

/** Root of a popover (controls open state). */
export const Popover = PopoverPrimitive.Root

/** Element that toggles the popover when activated. */
export const PopoverTrigger = PopoverPrimitive.Trigger

/** Element that closes the popover when activated. */
export const PopoverClose = PopoverPrimitive.Close

/**
 * The floating popover panel, portaled to the body. A flat floating layer:
 * hairline border + the dialog shadow, on the design-system surface tokens.
 */
export const PopoverContent = React.forwardRef<
  React.ComponentRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content>
>(function PopoverContent({ className, align = 'start', sideOffset = 6, ...props }, ref) {
  return (
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Content
        ref={ref}
        align={align}
        sideOffset={sideOffset}
        className={cn(
          'z-50 w-auto rounded-md border border-line bg-surface p-3 text-ink shadow-md outline-none',
          'motion-safe:animate-[ds-tooltip-in_120ms_var(--ds-ease-out)]',
          className,
        )}
        {...props}
      />
    </PopoverPrimitive.Portal>
  )
})
